import React from "react";
import { ILostAndFoundPetsResponseModel } from "../../../../typings/models/LostAndFoundPetsResponseModel";
import moment from "moment";

interface RowProps {
  data: ILostAndFoundPetsResponseModel;
}

const LostAndFoundPetsGridRow: React.FC<RowProps> = ({ data }) => {
  return (
    <tr>
      <td>{data.applicationID}</td>
      <td>{data.applicantName}</td>
      <td>
        {data.applicantIdType === "2" && "NRIC"}
        {data.applicantIdType === "1" && "FIN"}
        {data.applicantIdType === "4" && "UEN"}
      </td>
      <td>{data.applicantIdNumber}</td>
      <td>{data.locationWherePetIsFound}</td>
      <td>{data.remarks}</td>
      <td>{data.applicantMobileNumber}</td>
      <td>{data.applicantEmailAddress}</td>
      <td>{moment(data.DateWhenPetWasFound).format("DD/MM/yyyy, hh:mm a")}</td>
      <td>{data.microchipNo}</td>
      <td>{data.description}</td>
      <td>{moment(data.createdOn).format("DD/MM/yyyy, hh:mm a")}</td>
      {/* <td>Implement status logic here if needed</td> */}
    </tr>
  );
};

export default LostAndFoundPetsGridRow;
